<template>
   <div>
      <div class="container-mobile">
         <router-link
            :to="{ name: 'visites.create', params: {
               ruche_id: $route.params.id
            } }"
            class="ajouter"
         >
            <b-icon icon="plus-circle"></b-icon>Enregistrer une nouvelle visite
         </router-link>
      </div>

      <!-- BLOC Infos   -->
      <BlocInfos />

      <!-- BLOC VISITES  -->
      <BlocVisites />

      <!-- Bloc taches  -->
      <BlocTaches />
   </div>
</template>

<script>
   import BlocInfos from "./blocs/BlocInfos";
   import BlocVisites from "./blocs/BlocVisites";
   import BlocTaches from "./blocs/BlocTaches";

   export default {
      components: {
         BlocTaches,
         BlocVisites,
         BlocInfos
      },

      mounted() {
         this.$store.commit("setTitre", "Fiche ruche");
      }
   };
</script>
